export enum AdminProductQuantityHistoryReasonType {
  NewProduct = 'NEW_PRODUCT',
  ByNewOrder = 'BY_NEW_ORDER',
  ByAddToOrderShipment = 'BY_ADD_TO_ORDER_SHIPMENT',
  ByRemoveFromOrderShipment = 'BY_REMOVE_FROM_ORDER_SHIPMENT',
  ByCancelOrder = 'BY_CANCEL_ORDER',
  ByRefundOrder = 'BY_REFUND_ORDER',
  Manual = 'MANUAL',
}
